import { PAGE_LEVEL } from '@/constants';

// 点评
export default {
  meta: { localeModules: ['comment', 'report'] },
  path: '/comment',
  redirect: '/comment/index',
  children: [
    {
      // 点评列表页
      path: 'index',
      name: 'comment',
      component: () => import(/* webpackChunkName: 'report-manage' */ '@/pages/comment/index.vue'),
      meta: {
        name: 'routers.comment',
        componentName: 'CommentListIndex',
        pageLevel: PAGE_LEVEL.FIRST,
        keepAlive: true
      }
    },
    {
      // 点评详情页（供中转页 / 模型组链接跳转）
      path: 'detail/:id',
      name: 'commentDetail',
      component: () => import(/* webpackChunkName: 'comment-detail' */ '@/pages/comment/detail/index.vue'),
      meta: {
        localeModules: ['member'],
        name: 'routers.comment',
        parent: '/comment/index',
        otherParent: ['/find/list', '/find/self-selected', '/aiChat/index'],
        electronSingle: true,
        dynamicTitle: true,
        keepAlive: false,
        pageLevel: PAGE_LEVEL.SECOND,
        hideOuterBreadcrumb: true
      }
    }
  ]
};
